import React from "react";
import ResourcesLogo from "../../assets/headings/resources.svg";
import QuickLinks from "../../assets/headings/quick-links.svg";
import Emails from "../../assets/headings/emails.svg";
import { SectionProps } from "../../App";
import { getCourseContent } from "../../data/courseContent";
import "./Resources.scss";

export class Resources extends React.Component<SectionProps> {
  render() {
    const { contactLinks, quickLinks, resourceCategories } = getCourseContent();
    return (
      <section className={`resources ${this.props.static ? "static" : ""}`}>
        <div id="resources" className="content-container">
          <div className="header-container">
            <div className="section-heading">
              <img className="resources-logo logo" src={ResourcesLogo} alt="resources text" />
            </div>
          </div>
          <div className="resources-top-section">
            <div className="resources-sub-section">
              <center><img className="resources-title-svg" src={QuickLinks} alt="quick links" /></center>
              <div className="quick-links-container">
                {quickLinks.map((link) => (
                  <div className="card-rq resources-title" key={link.label}>
                    <p className="quick-link-p">
                      <a className="quick-link-a" href={link.href}>
                        {link.label}
                        <span className="link-spanner" />
                      </a>
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="resources-sub-section">
              <center><img className="resources-title-svg" src={Emails} alt="email contacts" /></center>
              <div className="emails-container">
                {[contactLinks.ta, contactLinks.hta, contactLinks.individual].map((contact) => {
                  const isMailto =
                    contact.address.includes("@") && !contact.address.startsWith("<");
                  return (
                    <div className="email-link-box" key={contact.label}>
                      <p className="email-link">
                        <span className="email-link-label">{contact.label}:</span>{" "}
                        {isMailto ? (
                          <a href={`mailto:${contact.address}`}>{contact.address}</a>
                        ) : (
                          contact.address
                        )}
                      </p>
                      <p className="email-link-note">{contact.description}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="card-container-links">
            {resourceCategories.map((category) => (
              <article className="resource-card" key={category.title}>
                <h3 className="resource-title">{category.title}</h3>
                <ul className="resource-link-list">
                  {category.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
    );
  }
}
